// src/web/client/src/components/activity/MessageDetailsDialog.jsx
// Full preview + stats of one email this app sent. Opened from the Activity log.
// Verbatim from pages/Messages.jsx (where the sent list used to live).
import React from 'react';
import { Badge } from '@/components/ui/badge';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { formatSentDate, getMessageTypeColor, formatMessageType, getStatusConfig } from './messageDisplay';

export default function MessageDetailsDialog({ message, open, onOpenChange }) {
  if (!message) return null;
  const sentLabel = formatSentDate(message);
  const openedLabel = message.opened ? `Yes (${message.open_count || 1} ${(message.open_count || 1) === 1 ? 'time' : 'times'})` : 'No';
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-3xl w-full max-h-[80vh] flex flex-col overflow-hidden">
        <DialogHeader className="pb-2">
          <DialogTitle className="text-xl font-semibold truncate">{message.subject || 'Message details'}</DialogTitle>
          <DialogDescription className="text-sm text-slate-500">Full preview and statistics for this message.</DialogDescription>
        </DialogHeader>
        <div className="mt-1 mb-2 text-sm text-slate-700">
          <span className="font-medium">To:</span>{' '}
          <span>{message.customer_name || message.customer_email || 'Unknown'}</span>
          {message.customer_email && <span className="text-slate-500"> ({message.customer_email})</span>}
        </div>
        <div className="flex flex-wrap items-center gap-2 mb-4">
          <Badge className={getMessageTypeColor(message.type)}>{formatMessageType(message.type)}</Badge>
          <Badge variant={getStatusConfig(message).variant}>{getStatusConfig(message).label}</Badge>
          {sentLabel && <span className="text-xs text-slate-500">Sent at {sentLabel}</span>}
        </div>
        <div className="border rounded-md bg-slate-50 px-4 py-3 text-xs text-slate-700 space-y-1 mb-4">
          {message._id && <p><span className="font-semibold">Message ID:</span> <span className="font-mono text-[11px] break-all">{message._id}</span></p>}
          {message.order_id && <p><span className="font-semibold">Order ID:</span> <span className="font-mono text-[11px] break-all">{message.order_id}</span></p>}
          <p><span className="font-semibold">Opened:</span> {openedLabel}</p>
        </div>
        <div className="flex-1 min-h-0 rounded-md border bg-white px-4 py-3 text-sm text-slate-800 overflow-y-auto">
          {message.content
            ? <div className="prose max-w-none text-sm" dangerouslySetInnerHTML={{ __html: message.content }} />
            : <p className="text-slate-500 italic">No content captured for this message.</p>}
        </div>
      </DialogContent>
    </Dialog>
  );
}
